import { Component } from '@opten/compiler/metadata/component';

declare const ltBanner: any;

@Component({ className: 'js-cookieConsent' })
export class CookieConsentComponent {
	constructor(private element: HTMLElement) {
		if (typeof ltBanner !== 'undefined') {
			if (ltBanner.consent.optionalFunctionality) {
			} else {
				this.showElement();
				window.addEventListener('ltBanner:ConsentChanged', function () {
					if (ltBanner.consent.optionalFunctionality) {
						this.hideElement();
					}
				});
			}
		}
	}

	hideElement() {
		this.element.classList.add('c-cookie-consent--hide');
	}
	showElement() {
		this.element.classList.remove('c-cookie-consent--hide');
	}
}
